"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/SNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_211)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_211`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V23.9994H-6V-0.00012207Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.2177 -0.00012207H30V24.0002H17.2177V-0.00012207Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H6.78233V24.0002H-6V-0.00012207ZM11.9999 7.82574L13.0359 11.0142H16.3887L13.6763 12.985L14.7123 16.1735L11.9999 14.2029L9.2875 16.1735L10.3237 12.985L7.61132 11.0142H10.9639L11.9999 7.82574Z",
					fill: "#496E2D"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_211`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as SNFlag };
